import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { link } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  header {
    title[]{${richTextFields}},
    ${link.fragment('link')}
  },
  items[] {
    title,
    content[]{${richTextFields}},
    ${link.fragment('link')}
  }
`

export const fragment = (name = 'contentStacks') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
